// src/api/templateApi.js
import axios from 'axios';

const API_URL = `${process.env.REACT_APP_API_BASE_URL}/template`;

/**
 * Get all templates with optional filtering
 * @param {Object} options - Filter options
 * @returns {Promise<Array>} List of templates
 */
export const fetchAllTemplates = async (options = {}) => {
  const { sort, order, search } = options;
  
  // Build query string
  const params = new URLSearchParams();
  if (sort) params.append('sort', sort);
  if (order) params.append('order', order);
  if (search) params.append('search', search);
  
  const queryString = params.toString();
  const url = queryString ? `${API_URL}?${queryString}` : API_URL;
  
  const response = await axios.get(url);
  return response.data;
};

/**
 * Get a template by ID
 * @param {string} id - Template ID
 * @returns {Promise<Object>} Template object
 */
export const fetchTemplateById = async (id) => {
  const response = await axios.get(`${API_URL}/${id}`);
  return response.data;
};

/**
 * Create a new template
 * @param {Object} templateData - Template data
 * @returns {Promise<Object>} Created template
 */
export const createTemplate = async (templateData) => {
  const response = await axios.post(API_URL, templateData);
  return response.data;
};

/**
 * Update an existing template
 * @param {string} id - Template ID
 * @param {Object} templateData - Template data to update
 * @returns {Promise<Object>} Updated template
 */
export const updateTemplate = async (id, templateData) => {
  const response = await axios.put(`${API_URL}/${id}`, templateData);
  return response.data;
};

/**
 * Delete a template
 * @param {string} id - Template ID
 * @returns {Promise<boolean>} Success indicator
 */
export const deleteTemplate = async (id) => {
  await axios.delete(`${API_URL}/${id}`);
  return true;
};